/**
 * 语言同步 Composable
 * 统一处理语言状态同步到 i18n 和 HTML lang 属性
 *
 * 使用方式：
 * import { setupLocaleSync } from '@/composables/useLocaleSync'
 * setupLocaleSync()
 */
import { watch } from 'vue'
import { useGlobalStore } from '@/stores/global'
import i18n from '@/locales'

export function setupLocaleSync() {
  const globalStore = useGlobalStore()

  watch(
    () => globalStore.locale,
    (locale) => {
      // 同步 i18n
      i18n.global.locale.value = locale

      // 同步 <html lang>
      if (typeof document !== 'undefined') {
        document.documentElement.lang = locale
      }
    },
    { immediate: true }
  )
}
